import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { partnerList } from "bodycodi/cmap/app/api/partner";

export interface PartnerState {
  partnerList: [];
  seqPartner: number;
  seqPartnerBranch: number;
  seqPartnerCoach: number;
  partnerName: string;
  partnerBranchName: string;
  loading: boolean;
}

const initialState: PartnerState = {
  seqPartner: 0,
  seqPartnerBranch: 0,
  seqPartnerCoach: 0,
  partnerName: "",
  partnerBranchName: "",
  partnerList: [],
  loading: false,
};

export const fetchPartnerList = createAsyncThunk("qna/fetchPartnerList", async () => {
  return await partnerList();
});

const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    setParterBranch(state, action) {
      state.seqPartner = action.payload.seqPartner;
      state.seqPartnerBranch = action.payload.seqPartnerBranch;
      state.seqPartnerCoach = action.payload.seqPartnerCoach;
      state.partnerName = action.payload.partnerName;
      state.partnerBranchName = action.payload.partnerBranchName;
    },
    setPartnerList(state, action) {
      state.partnerList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPartnerList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPartnerList.fulfilled, (state, action) => {
      action.payload.map((v: any) => {
        if (v.mainPartnerFlag === 1) {
          state.seqPartner = v.seqPartner;
          state.seqPartnerBranch = v.seqPartnerBranch;
          state.seqPartnerCoach = v.seqPartnerCoach;
          state.partnerName = v.partnerName;
          state.partnerBranchName = v.partnerBranchName;
        }
      });
      state.partnerList = action.payload;

      state.loading = false;
    });
  },
});

export const { setParterBranch, setPartnerList } = partnerSlice.actions;

export default partnerSlice.reducer;
